import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasets, getEntitlements, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    memberId: props.params.memberId,
    role: getRole(state),
  }),
  required: ["account", "memberId"],
  data: [{
    resource: "member",
    url: ({ memberId }) => {
      return {
        id: `member-${memberId}`,
        query: `query($memberId: IdOrEmail!) {
          member(id: $memberId) {
            name
            teams{
              alias
            }
          }
        }`,
        variables: {
          memberId,
        },
      }
    },
  },
  {
    resource: "memberDatasetEntitlements",
    passthrough: true,
    url: ({ account, memberId }) => `/api/${account}/reports/entitlements/member/${memberId}`,
  }, {
    resource: "adminDatasets",
    url: ({ role, account }) => role === "admin" ? `/api/${account}/datasets` : null,
  }],
  mapStateToProps: (state, props) => ({
    userId: get(state, "user.id"),
    datasets: getDatasets(state, props),
    entitlements: getEntitlements(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
